import CardAboutModal from "./CardAboutModal";
import PlayBox from "./PlayBox";
import ThisIsModal from "./ThisIsModal";
import Thumbnail from "./Thumbnails";
import { Songcard } from "@/types";
import {
  Card,
  CardBody,
  Center,
  Divider,
  HStack,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Link from "next/link";
import { useRef, useState } from "react";

interface FeaturedCardProps {
  embed: boolean;
  card: Songcard;
}

const FeaturedCard = ({ card, embed }: FeaturedCardProps) => {
  const { colorMode } = useColorMode();
  const ref = useRef(null);
  const [modelOpen, setModalOpen] = useState(false);

  return (
    <div ref={ref}>
      <>
        <br />
        <Center>
          <Card
            maxW="xs"
            align="center"
            bgColor={colorMode == "dark" ? "black" : "white"}
            variant="outline"
            borderColor={colorMode == "dark" ? "white" : "black"}
            borderStyle="dotted"
            borderRadius={15}
            shadow={"md"}
          >
            <CardBody>
              <div onClick={() => setModalOpen(true)}>
                <Thumbnail
                  ext_file={card.ext_file}
                  comp_file={card.comp_file}
                  image={card.image}
                />
              </div>
              <br />
              <Center>
                <PlayBox card={card} />
              </Center>
              {!embed && (
                <Text ml={4} mb={3} mt={5}>
                  is a Songcard from
                  <br />
                  {card.primary_artist && (
                    <Text as="b" key={card.primary_artist.slug}>
                      <Link href={`/artists/${card.primary_artist.slug}`}>
                        {card.primary_artist.name}
                      </Link>
                    </Text>
                  )}
                </Text>
              )}
              <Divider mb={5} />
              {!embed && (
                <Center>
                  <HStack justify="space-between" w="94%">
                    <CardAboutModal card={card} price={false} showOpen={true} />
                    <ThisIsModal
                      card={card}
                      price={false}
                      showOpen={modelOpen}
                      setModalOpen={setModalOpen}
                    />
                  </HStack>
                </Center>
              )}
              {embed && (
                <Center>
                  <Link
                    href={`https://songcards.io/cards/${card.uuid}`}
                    target="_blank"
                  >
                    View Card
                  </Link>
                </Center>
              )}
            </CardBody>
          </Card>
        </Center>
      </>
    </div>
  );
};

export default FeaturedCard;
